new nc.promokit.Preloader({
    'delay':600,
    'image':[
        '/promo/bns/history/2018/180321_circus/img/section1_bg.jpg',
        '/promo/bns/history/2018/180321_circus/img/section2_bg.jpg',
        '/promo/bns/history/2018/180321_circus/img/section3_bg.jpg',
        '/promo/bns/history/2018/180321_circus/img/section4_bg.jpg',
        '/promo/bns/history/2018/180321_circus/img/section5_bg.jpg',
        '/promo/bns/history/2018/180321_circus/img/menu_tit1.png',
        '/promo/bns/history/2018/180321_circus/img/menu_tit2.png',
        '/promo/bns/history/2018/180321_circus/img/section1_tit1_1.png',
        '/promo/bns/history/2018/180321_circus/img/section1_tit1_2.png',
        '/promo/bns/history/2018/180321_circus/img/btn_movie.png',
        '/promo/bns/history/2018/180321_circus/img/section2_tit.png',
        '/promo/bns/history/2018/180321_circus/img/section2_txt1.png',
        '/promo/bns/history/2018/180321_circus/img/section2_txt2.png',
        '/promo/bns/history/2018/180321_circus/img/section2_cht1.png',
        '/promo/bns/history/2018/180321_circus/img/section2_cht2.png',
        '/promo/bns/history/2018/180321_circus/img/section2_thumb1.jpg',
        '/promo/bns/history/2018/180321_circus/img/section2_thumb2.jpg',
        '/promo/bns/history/2018/180321_circus/img/section2_thumb3.jpg',
        '/promo/bns/history/2018/180321_circus/img/section2_thumb4.jpg',
        '/promo/bns/history/2018/180321_circus/img/section3_con_list1.png',
        '/promo/bns/history/2018/180321_circus/img/section3_con_list2.png',
        '/promo/bns/history/2018/180321_circus/img/section3_con_list3.png',
        '/promo/bns/history/2018/180321_circus/img/section4_tit.png',
        '/promo/bns/history/2018/180321_circus/img/section4_txt1.png',
        '/promo/bns/history/2018/180321_circus/img/section4_txt2.png',
        '/promo/bns/history/2018/180321_circus/img/section4_con_list1.png',
        '/promo/bns/history/2018/180321_circus/img/section4_con_list2.png',
        '/promo/bns/history/2018/180321_circus/img/section5_tit.png',
        '/promo/bns/history/2018/180321_circus/img/section4_flower1.png',
        '/promo/bns/history/2018/180321_circus/img/section4_flower2.png',
        '/promo/bns/history/2018/180321_circus/img/section5_con_list1.png',
        '/promo/bns/history/2018/180321_circus/img/section5_con_list2.png',
        '/promo/bns/history/2018/180321_circus/img/nav_bg_on.png',
        '/promo/bns/history/2018/180321_circus/img/nav_bg_off.png',
        '/promo/bns/history/2018/180321_circus/img/section1_flower1.png',
        '/promo/bns/history/2018/180321_circus/img/section1_flower2.png',
        '/promo/bns/history/2018/180321_circus/img/section1_cht1.png',
        '/promo/bns/history/2018/180321_circus/img/section1_cht2.png',
        '/promo/bns/history/2018/180321_circus/img/section3_flower1.png',
        '/promo/bns/history/2018/180321_circus/img/section3_flower2.png',
        '/promo/bns/history/2018/180321_circus/img/section3_cht1.png',
        '/promo/bns/history/2018/180321_circus/img/section3_bubble.png',
        '/promo/bns/history/2018/180321_circus/img/section5_flower1.png',
        '/promo/bns/history/2018/180321_circus/img/section5_flower2.png',
        '/promo/bns/history/2018/180321_circus/img/section5_cht1.png',
        '/promo/bns/history/2018/180321_circus/img/section1_cht2.png',
        '/promo/bns/history/2018/180321_circus/img/layer_img1.jpg',
        '/promo/bns/history/2018/180321_circus/img/layer_img2.jpg',
        '/promo/bns/history/2018/180321_circus/img/layer_img3.jpg',
        '/promo/bns/history/2018/180321_circus/img/layer_img4.jpg',
        '/promo/bns/history/2018/180321_circus/img/item_layer_img.png'
    ],
    'youtbue':["5ZD0g9erPpI"]
});

$(document).on('preloadend', function(){
    setTimeout(function(){
        new circus.option({
            element:"#container",
            idx:0
        });
    }, 600);
});

var circus = (function(window, document, $, undefined){

    var $con = $("[data-contents='section']"), $gnb = $(".navi_wrap").find("li");
    var gnbNum, scChk = false;
    var s1 = new TimelineMax({paused:true}),
        s2 = new TimelineMax({paused:true}),
        s3 = new TimelineMax({paused:true}),
        s4 = new TimelineMax({paused:true}),
        s5 = new TimelineMax({paused:true});

    var layerMovie = new nc.promokit.Player({
        selector: '#movieBox',
        videoId: '5ZD0g9erPpI',
        mute:false,
        controls:true,
        coverClick:true,
        loop:false
    });

    function init(opts){
        $(".container").stop().animate({opacity:1}, 300);
        // $("html, body").css({overflowY:"auto"});
        $.each($(opts.element), function(i, item) {
            var obj     = {};
            obj.element  = item;
            obj.idx = opts.idx;
            obj.len = $(item).find($con).length;
            gnbNum = obj.idx;
            controls(obj);
            scrollAction(obj);
        });

        s1Animation();
        s2Animation();
        s3Animation();
        s4Animation();
        s5Animation();
        navAnchor();
    };

    function controls(obj){
        $(window).on("scroll", function(){
            if(scChk){
                scrollAction(obj);
                navAnchor();
            }
            scChk = true;
        });

        $(".menu_bg").children("h1").on("click", function(){
            arrowSlide();
        });

        $(".btn_menu").on("click", function(){
            arrowSlide();
        });

        $gnb.on("click", function(){
            var id = $(this).data("href");
            listSlide(id);
            arrowSlide();
        });

        $(".scroll_txt").on("click", function(){
            listSlide("#slideSection2");
            if($(".menu_bg").hasClass("on")){
                arrowSlide();
            }
        });

        $(".btn_play").on("click", function(){
            layerMovie.play();
        });

        $("#movieLayer").children(".layer_close").on("click", function(){
            layerMovie.stop();
        });

        $(".cht_layer").mouseenter(function() {
            var target = $(".cht_layer").index(this);
            cht1Animation("over", target);
        }).mouseleave(function() {
            var target = $(".cht_layer").index(this);
            cht1Animation("out", target);
        });
    };

    function cht1Animation(target, num){
        if (target=="over"){
            if(num==0){
                TweenMax.to($(".cht_bg").eq(num), 0.6, {x:-200, scale:1.0, ease:Power1.easeOut});
            }else{
                TweenMax.to($(".cht_bg").eq(num), 0.6, {x:200, scale:1.0, ease:Power1.easeOut});
            }
        }else if(target=="out"){
            if(num==0){
                TweenMax.to($(".cht_bg").eq(num), 0.6, {x:0, scale:0.72, ease:Power1.easeOut});
            }else{
                TweenMax.to($(".cht_bg").eq(num), 0.6, {x:0, scale:0.68, ease:Power1.easeOut});
            }
        }
    };

    function arrowSlide(){
        if(!$(".menu_bg").hasClass("on")){
            $(".menu_bg").addClass("on");
            $(".btn_menu").addClass("on");
        }else{
            $(".menu_bg").removeClass("on");
            $(".btn_menu").removeClass("on");
        }
    };

    function scrollAction(obj){
        var scltop = $(window).scrollTop(),
            firstTop = $(obj.element).find($con.eq(0)).offset().top,
            lastBottom = $(obj.element).find($con.eq($con.length - 1)).offset().top + $(obj.element).find($con.eq($con.length - 1)).height(),
            endScroll = $(window).scrollTop() == $(document).height() - $(window).height();
        for(var i = 0; i < obj.len; i++) {
            var conTop = $(obj.element).find($con.eq(i)).offset().top-400;
            if(conTop <= scltop) {
                gnbNum = i;
            }
            removeChk = (scltop < firstTop || scltop > lastBottom) ? true : false;
        }

        if(scltop >= $("#div_nctop").height()) {
            $("#header").addClass("fixed");
        }else{
            $("#header").removeClass("fixed");
        }

        if(!removeChk) {
            scrollAnimation(endScroll);
        } else {
            console.log("아니야~!")
        }
    };

    function scrollAnimation(endScroll){
        if(!endScroll){
            switch (gnbNum){
                case 0 :
                    s1.play();
                    break;
                case 1 :
                    s2.play();
                    break;
                case 2 :
                    s3.play();
                    break;
                case 3 :
                    s4.play();
                    break;
                case 4 :
                    s5.play();
                    break;
            }
        }else{
            s5.play();
        }
    };

    function s1Animation(){
        s1.from($(".section1").find($(".tit_etc")), 0.6, {y:60, alpha:0, ease:Circ.easeOut}, "+=0.3")
        .from($(".section1").find($(".tit1_1")), 0.6, {x:80, alpha:0, ease:Power1.easeOut}, "-=0.1")
        .from($(".section1").find($(".tit1_2")), 0.6, {x:-80, alpha:0, ease:Power1.easeOut}, "-=0.6")
        .from($(".section1").find($(".stit1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.25")
        .from($(".section1").find($(".stit2")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .from($(".section1").find($(".btn_play")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .from($(".section1").find($(".scroll_txt")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .from($(".section1").find($(".cht1")), 0.8, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.3")
        .from($(".section1").find($(".cht2")), 0.8, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.8")
        .from($(".section1").find($(".flower2")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.45")
        .from($(".section1").find($(".flower1")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.45")
        .staggerFrom([
            $(".section1").find($(".tit_effect1")),
            $(".section1").find($(".tit_effect2")),
            $(".section1").find($(".tit_effect3")),
            $(".section1").find($(".tit_effect4")),
            $(".section1").find($(".tit_effect5")),
            $(".section1").find($(".tit_effect6")),
            $(".section1").find($(".tit_effect7"))
        ], 0.8, {x:-60, y:-60, alpha:0, ease:Power1.easeOut}, 0.04, "-=0.15");
    };

    function s2Animation(){
        s2.from($(".section2").find($("h1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.1")
        .from($(".section2").find($(".stit1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.25")
        .from($(".section2").find($(".stit2")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .from($(".section2").find($(".cht1")), 0.8, {x:400, alpha:0, ease:Power1.easeOut}, "-=0.2")
        .from($(".section2").find($(".cht2")), 0.8, {x:-400, alpha:0, ease:Power1.easeOut}, "-=0.8")
        .staggerFrom([
            $(".section2").find($(".section2_thumb>.thumb1")),
            $(".section2").find($(".section2_thumb>.thumb2")),
            $(".section2").find($(".section2_thumb>.thumb3")),
            $(".section2").find($(".section2_thumb>.thumb4")),
        ], 0.5, {y:60, alpha:0, ease:Power1.easeOut}, 0.15, "-=0.25");
    };

    function s3Animation(){
        s3.from($(".section3").find($("h1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.1")
        .from($(".section3").find($(".stit1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.25")
        .from($(".section3").find($(".stit2")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .staggerFrom([
            $(".section3").find($(".con_list>.list1")),
            $(".section3").find($(".con_list>.list2")),
            $(".section3").find($(".con_list>.list3")),
        ], 0.5, {y:60, alpha:0, ease:Power1.easeOut}, 0.15, "-=0.25")
        .from($(".section3").find($(".cht1")), 0.8, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.2")
        .from($(".section3").find($(".flower1")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.45")
        .from($(".section3").find($(".flower2")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.35")
            .from($(".section3").find($(".bubble")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.72");
    };

    function s4Animation(){
        s4.from($(".section4").find($("h1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.1")
        .from($(".section4").find($(".stit1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.25")
        .from($(".section4").find($(".stit2")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.36")
        .staggerFrom([
            $(".section4").find($(".con_list>.list1")),
            $(".section4").find($(".con_list>.list2")),
        ], 0.5, {y:60, alpha:0, ease:Power1.easeOut}, 0.15, "-=0.25")
        .from($(".section4").find($(".cht2")), 0.8, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.2")
        .from($(".section4").find($(".flower2")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.45")
        .from($(".section4").find($(".flower1")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.35");
    };

    function s5Animation(){
        s5.from($(".section5").find($("h1")), 0.6, {y:80, alpha:0, ease:Power1.easeOut}, "-=0.1")
        .staggerFrom([
            $(".section5").find($(".con_list>.list1")),
            $(".section5").find($(".con_list>.list2")),
        ], 0.5, {y:60, alpha:0, ease:Power1.easeOut}, 0.15, "-=0.25")
        .from($(".section5").find($(".update_note")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.25")
        .from($(".section5").find($(".cht1")), 0.8, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.2")
        .from($(".section5").find($(".flower1")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.45")
        .from($(".section5").find($(".flower2")), 0.6, {y:100, alpha:0, ease:Power1.easeOut}, "-=0.35");
    };

    function navAnchor(){
        if(gnbNum!=0){
            gnbNum = gnbNum-1;
            $gnb.removeClass("active");
            $gnb.eq(gnbNum).addClass("active");
        }else{
            $gnb.removeClass("active");
        }
    };

    function listSlide(id){
        var conOffset = $(""+id+"").offset().top;
        $("html, body").stop().animate({scrollTop: conOffset}, 500);
    }

    return {
        option:init
    };
})(window, document, $);

var sliderModule = (function (window, document, $, undefined) {

    var $btn = $("[data-btn]"),
        $wrap = $("[data-gallery='wrap']"),
        $list = $("[data-slider='list']"),
        $paging = $("[data-list='paging']"),
        _pagingWrap = "data-paging='wrap'",
        _paging = "data-paging='list'";


    var init = function(opts){
        $.each(opts.element, function(i, item) {
            var obj     = {};
            obj.element  = item;
            obj.idx = opts.idx[i];
            obj.len = $(item).find($list).length;
            obj.paging = opts.paging[i];
            if(opts.pelement != undefined){
                obj.pelement = opts.pelement[i];
            }
            obj.setChk = true;

            var first = $(obj.element).find($list).first($list).clone();
            var last = $(obj.element).find($list).last($list).clone();
            $(obj.element).find($wrap).append(first);
            $(obj.element).find($wrap).prepend(last);

            sliderAnimation(obj);
            controls(obj);
        });
    };

    function controls(obj){
        $(obj.element).find($btn).off().on("click", function(e){
            var target = $(this).data("btn");
            prevnext(obj, target);
        });

        $(obj.element).find("["+_paging+"]").on("click", function(e){
            var thisNum = $(this).index();
            obj.idx = thisNum+1;
            sliderAnimation(obj);
        });

        $(obj.pelement).find($paging).on("click", function(e){
            var thisNum = $(this).index();
            obj.idx = thisNum+1;
            obj.setChk = true;
            sliderAnimation(obj);
        });
    };

    function prevnext(obj, target){
        if($(obj.element).find($wrap).is(":not(:animated)")){
            if(target=="next"){
                obj.idx = obj.idx+1;
                sliderAnimation(obj);
            }else if(target=="prev"){
                obj.idx = obj.idx-1;
                sliderAnimation(obj);
            }
        }
    };

    function sliderAnimation(obj){
        if(obj.setChk==true){
            obj.idx = (obj.idx>obj.len || obj.idx<=0) ? 1 : obj.idx;
            $(obj.element).find($wrap).css({left:-$(obj.element).width()*obj.idx});
            if(obj.paging==true){
                pagingSet(obj);
                sliderPaging(obj);
            }
            obj.setChk = false;
        }else{
            $(obj.element).find($wrap).stop().animate({left:-$(obj.element).width()*obj.idx}, function(){
                var cycle = (0===obj.idx || obj.len+1===obj.idx);
                if(cycle){
                    obj.idx = (obj.idx === 0)? obj.len : 1;
                    $(obj.element).find($wrap).css({left:-$(obj.element).width()*obj.idx});
                }
                if(obj.paging==true){
                    sliderPaging(obj);
                }
            });
        }
    }

    function sliderPaging(obj){
        $(obj.element).find($("["+_paging+"]")).removeClass("on");
        $(obj.element).find($("["+_paging+"]")).eq(obj.idx-1).addClass("on");
    }

    function pagingSet(obj){
        $(obj.element).find($wrap).after("<ul "+_pagingWrap+">");
        for ( var i=1 ; i<obj.len+1 ; i++ ){
            $(obj.element).find($("["+_pagingWrap+"]")).append("<li "+_paging+"><button type='button'>"+i+"");
        }
    }

    return{
        option:init
    };
})(window, document, $);

new sliderModule.option({
    element:["#slider1"],
    idx:[1],
    paging:[false],
    pelement:["#paging1"],
});